import React, { useState } from "react";
import ScrollContainer from "react-indiana-drag-scroll";
import { Link } from "react-scroll";
import { BsChevronDown } from "react-icons/bs";


const ItemListContainer = () => {

    const [modalMenu, setModalMenu] = useState(false);

    const toggleModal = () => {
        setModalMenu(!modalMenu);
    };

    if (modalMenu) {
        document.body.classList.add('active-modal')
    } else {
        document.body.classList.remove('active-modal')
    }



    return (
        <nav className="categories">
            <button className="menu-btn" onClick={toggleModal}>Menu  <BsChevronDown size={15} /></button>
            {modalMenu && (
                <div className="modal">
                    <div onClick={toggleModal} className="overlay"></div>
                    <div className="modal-content">
                        <h3 className="menu-sidebar">Menu</h3>
                        <ul className="category-list-menu">
                            <li className="category-list-item-menu">
                                <Link exact={true} onClick={toggleModal} className="modal-item" activeclassname="activeModal" smooth spy to="TriplesJQ">
                                    Triples J&Q
                                </Link>
                            </li>
                            <li className="category-list-menu">
                                <Link onClick={toggleModal} className="modal-item" activeclassname="activeModal" smooth spy to="TriplesSurtidos">
                                Triples Surtidos
                                </Link>
                            </li>
                            <li className="category-list-menu">
                                <Link onClick={toggleModal} className="modal-item" activeclassname="activeModal" smooth spy to="TriplesEspeciales">
                                Triples Especiales
                                </Link>
                            </li>
                            <li className="category-list-menu">
                                <Link onClick={toggleModal} className="modal-item" activeclassname="activeModal" smooth spy to="TortasMiga">
                                Tortas Miga
                                </Link>
                            </li>
                            <li className="category-list-menu">
                                <Link onClick={toggleModal} className="modal-item" activeclassname="activeModal" smooth spy to="Chipa">
                                Chipa
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            )}
            <div className="line-nav"></div>
            <ScrollContainer>
                <ul className="category-list">
                    <li>
                        <Link activeclassname="activeItem" smooth spy className="category-list-item about" to="TriplesJQ">
                        Triples J&Q
                        </Link>
                    </li>
                    <li>
                        <Link activeclassname="activeItem" smooth spy className="category-list-item projects" to="TriplesSurtidos">
                        Triples Surtidos
                        </Link>
                    </li>
                    <li>
                        <Link activeclassname="activeItem" smooth spy className="category-list-item blog" to="TriplesEspeciales">
                        Triples Especiales
                        </Link>
                    </li>
                    <li>
                        <Link activeclassname="activeItem" smooth spy className="category-list-item contact" to="TortasMiga">
                        Tortas Miga
                        </Link>
                    </li>
                    <li>
                        <Link activeclassname="activeItem" smooth spy className="category-list-item contact" to="Chipa">
                        Chipa
                        </Link>
                    </li>
                </ul>
            </ScrollContainer>
        </nav>
    );
    /*

        const scrollToSection = (term) => {
        if (term) {
            document.getElementById(term).scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
        }
    };
    window.onscroll = function () {
        const typeFilterReset = document.querySelector("#typeFilter");
        typeFilterReset.value = "Menu";
    }

    <select id="typeFilter" onChange={(event) => scrollToSection(event.target.value)}>
            <option value={"Menu"}>Menu</option>
                <option value={"Menu"}>Simples</option>
                <option value={"about"}>Especiales</option>
                <option value={"projects"}>Tortas</option>
                <option value={"blog"}>Chipa</option>
            </select>*/
}

export default ItemListContainer;